import { CommonModule } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { CardBinder, CardCondition } from '@models/binder.model';
import { Rarity, Variante, Card as CardM, CardSet } from '@models/card.model';
import { BinderService } from '@services/binder.service';
import { Card } from '@services/card.service';
import { Global } from '@services/global.service';
import { Router } from '@services/route.service';
import { StatDetailType, StatService } from '@services/stat.service';
import { forkJoin, switchMap } from 'rxjs';

@Component({
  selector: 'lgb-stats-overview',
  imports: [
    CommonModule,
    RouterModule,
    UiModule
  ],
  templateUrl: './stats-overview.html',
  styleUrl: './stats-overview.css',
})
export class StatsOverview {
  //service
  readonly global=inject(Global);
  readonly binderS=inject(BinderService);
  readonly cardS=inject(Card);
  readonly statsS=inject(StatService);
  readonly route=inject(ActivatedRoute);
  readonly router=inject(Router);

  //data
  readonly variantes=signal<Variante[]>([]);
  readonly rarities=signal<Rarity[]>([]);
  readonly conditions=signal<CardCondition[]>([]);
  readonly cardSet=signal<CardSet[]>([]);
  readonly type=signal<string>(null);

  //ui
  readonly loading=signal(false);
  readonly stats=signal<StatDetailType>(null);
  readonly open=signal(false);

  //stats
  readonly rarityStats=computed(() => this.stats()?.rarities.sort((a: any, b: any) => b.nb-a.nb));
  readonly varianteStats=computed(() => this.stats()?.variantes.sort((a: any, b: any) => b.nb-a.nb));
  readonly conditionStats=computed(() => this.stats()?.conditions.sort((a: any, b: any) => b.nb-a.nb));
  readonly topCard=computed(() => this.stats()?.top10.sort((a: CardBinder, b: CardBinder) => b.amount-a.amount));

  constructor(){
    this.loading.set(true);
    this.route.parent.paramMap
      .pipe(
        switchMap(params => {
          this.type.set(params.get("type"));
          return forkJoin({
            globals: this.global.init(),
            stats: this.statsS.getDetailStats(params.get("type")),
            cardSet: this.cardS.getCardSets()
          })
        })
      )
      .subscribe(result => {
        this.variantes.set(result.globals.variantes);
        this.rarities.set(result.globals.rarities);
        this.conditions.set(result.globals.conditions);
        this.stats.set(result.stats);
        this.cardSet.set(result.cardSet);
        this.loading.set(false);
      });
  }

  tx(){
    return ((this.stats().totalType)? this.stats().unique*100/this.stats().totalType : 0);
  }

  txCollect(nb: number){
    return ((this.stats().cards>0)? nb*100/this.stats().cards : 0);
  }

  getCardName(card: CardBinder){
    const ref: CardM=this.stats().topRef.find(c => c.ident==card.card);
    return this.cardS.getNameFeat(ref, card.lang).text;
  }

  getSetName(card: string){
    const ref: CardM=this.stats().topRef.find(c => c.ident==card);
    const cardSet: CardSet=this.cardSet().find(s => s.ident==ref.cardSet);
    return this.cardS.getCardSetName(cardSet, 'fr');
  }
}
